var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.524 3.533c-2.76 0-4.996 2.245-4.996 5.015 0 2.77 2.237 5.015 4.996 5.015 2.76 0 4.997-2.245 4.997-5.015 0-2.77-2.237-5.015-4.997-5.015ZM2.1 8.548C2.1 4.987 4.976 2.1 8.524 2.1c3.549 0 6.425 2.887 6.425 6.448 0 3.56-2.876 6.448-6.425 6.448-3.548 0-6.424-2.887-6.424-6.448Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.09 18.1-4.758-4.776 1.01-1.013 4.758 4.776-1.01 1.013Z",
    fill: "currentColor"
  })));
};
export default SvgSearch;